module.exports = __webpack_public_path__ + "img/clock-five-thirty.e58c637f.svg";